<div class="step2">
  <div class="list-steps">
    <app-steps [steps]="formService.steps" [currentStep]="1"></app-steps>
  </div>

  <div class="template-name step2-content">
    <div class="label">
      <div class="label-text">活動記録テンプレート名</div>
    </div>

    <div class="break-word">{{ workTemplate.title }}</div>
  </div>

  @for (question of remainingQuestions; track question; let i = $index) {
    <div class="step2-content">
      <div class="label">
        <div class="label-text">設問{{ i + 1 }}</div>
      </div>
      <div class="question-content">
        <div class="question-text break-word preserve-line-break">{{ question.content }}</div>
        @if (question.image_local) {
          <div class="image">
            <img appQuestionImagePreview [image]="question.image_local" />
          </div>
        } @else {
          @if (hasImageToBeUpdated(question)) {
            <div class="image">
              <div>
                <img src="{{ question.image_attributes['thumbnail'] }}" />
              </div>
            </div>
          }
        }
      </div>
    </div>
  }

  <div class="buttons-group step2-btn">
    <button type="button" class="spen-mod-btn is-default" (click)="goBack()" [disabled]="isSubmitting">戻る</button>
    <button type="button" class="spen-mod-btn is-primary" (click)="onSubmit()" [disabled]="isSubmitting">作成完了</button>
  </div>
</div>

@if (uploader.isUploading) {
  <app-upload-files-progress [progress]="uploader.progress" (cancelFilesEvent)="cancelUploadingFiles()"> </app-upload-files-progress>
}
